import { t } from 'i18next';

import * as apiPostSearch from 'api/baseIngredient/PostBaseIngredientSearchV1';
import * as RangeWithIdList from 'types/Accessory/Search/RangeWithIdList';
import * as Search from 'types/BaseIngredient/Search/Search';
import * as RangeWithId from 'types/Ingredient/Search/RangeWithId';

export type Type = RangeWithId.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi(archive: boolean): Promise<Type> {
	const response = await apiPostSearch.callApi(
		Search.mapToApi({
			...Search.create(),
			showOnlyDeleted: archive,
		})
	);
	const responseData = response.toNullable();
	if (responseData) {
		return mapFromApi(responseData);
	}
	return create();
}

export function mapFromApi(obj: apiPostSearch.ResponseData): Type {
	const result: Type = [];
	result.push({
		id: 'calories',
		minimum: obj.minMaxCaloriesRange.minimum,
		maximum: obj.minMaxCaloriesRange.maximum,
		label: `${t('_general:CALORIES')} (kcal)`,
	});
	result.push({
		id: 'co2',
		minimum: obj.minMaxCarbonDioxideRange.minimum,
		maximum: obj.minMaxCarbonDioxideRange.maximum,
		label: `${t('_general:CARBON_DIOXIDE')}`,
	});
	obj.minMaxNutrientRanges.forEach((x) => {
		result.push({
			id: x.nutrientInfo.id,
			minimum: x.range.minimum,
			maximum: x.range.maximum,
			label: `${x.nutrientInfo.name} (${x.nutrientInfo.unitShortNameSingular})`,
		});
	});
	return result;
}

export function getById(obj: Type, id: string): RangeWithId.Type {
	const output = obj.find((x) => x.id === id);
	if (output) return output;
	return RangeWithId.create();
}

export function mergeRangesWithSliders(ranges: RangeWithIdList.Type, search: Search.Type) {
	const slidersById = search.sliders.toDictionary(
		(x) => x.id,
		(x) => x
	);
	return ranges.map((e) => ({
		...e,
		left: slidersById[e.id]?.left ?? e.minimum,
		right: slidersById[e.id]?.right ?? e.maximum,
	}));
}
